import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';
import ProjectOutlined from '@ant-design/icons/ProjectOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';

const projetos = {
  id: 'group-projetos',
  title: 'Projetos',
  type: 'group',
  children: [
    {
      id: 'back-to-core-projetos',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      id: 'projetos-list',
      title: 'Projetos',
      type: 'item',
      url: '/projetos',
      icon: ProjectOutlined,
      permissions: ['projetos.projeto.view'],
      breadcrumbs: false
    },
    {
      id: 'projetos-minhas',
      title: 'Minhas tarefas',
      type: 'item',
      url: '/projetos/minhas-tarefas',
      icon: UserOutlined,
      permissions: ['projetos.minhas'],
      breadcrumbs: false
    },
    {
      id: 'projetos-relatorios',
      title: 'Relatórios',
      type: 'item',
      url: '/projetos/relatorios',
      icon: BarChartOutlined,
      permissions: ['projetos.projeto.view'],
      breadcrumbs: false
    },
    {
      id: 'projetos-arquivados',
      title: 'Arquivados',
      type: 'item',
      url: '/projetos/arquivados',
      icon: AppstoreOutlined,
      permissions: ['projetos.projeto.view'],
      breadcrumbs: false
    }
  ]
};

export default projetos;
